import React from "react";
import { Button, Panel, Table } from "@culturehq/components";
import { useProfile } from "app/context";
import { Trans } from "app/utils";
import { ExternalMapper } from "chq";
import ExternalMapperRow from "./settings/external-mappers/ExternalMapperRow";
import ExternalMapperModal from "./settings/external-mappers/ExternalMapperModal";
import { createEntity, deleteEntity, updateEntity } from "./settings/mutations";

const createExternalMapper = createEntity("externalMappers", "priority", true);
const updateExternalMapper = updateEntity("externalMappers", true);
const deleteExternalMapper = deleteEntity("externalMappers", true);

const SettingsJobMappers: React.FC<{}> = () => {
  const { profile, fetchedProfile } = useProfile();
  const { organization } = profile;
  const { externalMappers } = organization;

  const onUpdateExternalMappers = (newExternalMappers: ExternalMapper[]) => (
    fetchedProfile({
      ...profile,
      organization: {
        ...organization,
        externalMappers: newExternalMappers
      }
    })
  );

  const handleCreate = (value: ExternalMapper) => (
    onUpdateExternalMappers(createExternalMapper(value)(externalMappers) as ExternalMapper[])
  );

  const handleUpdate = (value: ExternalMapper) => (
    onUpdateExternalMappers(updateExternalMapper(value)(externalMappers) as ExternalMapper[])
  );
  const handleDelete = (value: ExternalMapper) => (
    onUpdateExternalMappers(deleteExternalMapper(value)(externalMappers) as ExternalMapper[])
  );

  return (
    <Panel limitWidth>
      <Panel.Heading primary>Job Mappers</Panel.Heading>
      <Panel.Body className="ManagExternalMappers">
        <ExternalMapperModal
          onCreate={handleCreate}
          onUpdate={handleUpdate}
        >
          {onTrigger => (
            <Button icon="plus" primary onClick={onTrigger}>
              <Trans>Add External Mapper</Trans>
            </Button>
          )}
        </ExternalMapperModal>
        <Table className="no-scrollbar">
          <thead>
            <tr>
              <th><Trans>Label</Trans></th>
              <th><Trans>Priority</Trans></th>
              <th><Trans>Icon</Trans></th>
              <th><Trans>Multiselect Field</Trans></th>
              <th><Trans>Allow Users to Create new Values</Trans></th>
              <th><Trans>HTML Attribute ID</Trans></th>
              <th className="actions"><Trans>Actions</Trans></th>
            </tr>
          </thead>
          <tbody>
            {externalMappers?.map(externalMapper => (
              <ExternalMapperRow
                key={externalMapper.id}
                externalMapper={externalMapper}
                onUpdate={handleUpdate}
                onDelete={handleDelete}
              />
            ))}
          </tbody>
        </Table>
      </Panel.Body>
    </Panel>
  );
};

export default SettingsJobMappers;
